module.exports = __webpack_public_path__ + "static/media/006-pompom-pink.c9be3d46.svg";